module.exports = __webpack_public_path__ + "static/media/temp-foto-hero-mob-3.6fad717a.jpg";